import { Expose } from 'class-transformer';

export class QuarteredForecastPart {
  @Expose()
  temperature: number;

  @Expose({ name: 'feels_temp' })
  feelTemperature: number;

  @Expose({ name: 'icon_url' })
  icon: string;

  @Expose({ name: 'description' })
  description: string;

  @Expose({ name: 'precipitation' })
  precipitation: number;

  @Expose({ name: 'humidity' })
  humidity: number;

  @Expose({ name: 'pressure' })
  pressure: number;

  @Expose({ name: 'wind_speed' })
  windSpeed: number;

  @Expose({ name: 'wind_direction' })
  windDirection: string;

  @Expose({ name: 'wind_degrees' })
  windDegrees: number;

  @Expose({ name: 'wind_speed_abnormal' })
  isWindSpeedAbnormal: boolean;

  @Expose({ name: 'precipitation_abnormal' })
  isPrecipitationAbnormal: boolean;
}
